// Keep in sync with VixieesViewSet.authorized_users in the backend
// (fpf/utils/vixiees/views.py): the /api/vixiees/ endpoints answer 403 to
// anyone else, so listing an extra email here only shows a broken page.
export default [
  'jonathan@foodforjoe.com',
  'albane@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'paolo.troni@foodforjoe.es',
  'tania@foodforjoe.es',
  'marcela@foodforjoe.es',
];
